import { render, staticRenderFns } from "./add.vue?vue&type=template&id=d63a51ea&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=d63a51ea&prod&scoped=true&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=d63a51ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63a51ea",
  null
  
)

export default component.exports